// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VacancySpecification_wrapper__rL_88","icon":"VacancySpecification_icon__wpc4m","value":"VacancySpecification_value__FYsGO"};